import Row from "../../atoms/Row";
import styled from "styled-components";

export const FooterContainer = styled(Row)`
  position: absolute;
  bottom: 40px;
  justify-content: center;
  align-items: center;
  width: 100vw;
  color: rgba(255, 255, 255, 0.7);
  font-size: 12px;
  font-weight: 400;

  & a {
    color: rgba(255, 255, 255, 0.7);
  }
`;

export const HeartContainer = styled.span`
  color: #e25555;
`;
